import "bootstrap-v4-rtl/dist/css/bootstrap-rtl.min.css";
import "./pwa-component/style.css";
import "./App.css";
import "./pwa-component/modal.css";
import MyComponent from "./pwa-component/prompt";
import "font-awesome/css/font-awesome.min.css";
// import PWAPrompt from "react-ios-pwa-prompt";
import { Routes, Route, BrowserRouter as Router } from "react-router-dom";
import { useState, useEffect } from "react";
import SocketIOClient from "socket.io-client";
import "isomorphic-fetch";
import Navbar from "./pwa-component/Navbar";
import TabBar from "./pwa-component/TabBar";
import Info from "./pwa-component/Info";
import Contact from "./pwa-component/Contact";

function App() {
  const { REACT_APP_URL } = process.env;

  const [tableCur, setTableCur] = useState([]);
  const [tableCoin, setTableCoin] = useState([]);
  const [msg, setMsg] = useState("");
  const [configs, setConfigs] = useState([]);
  const [scroll, setScroll] = useState();

  useEffect(() => {
    //* informations to create sth unique
    // const userAgent = navigator.userAgent;
    // console.log("User Agent:", userAgent);

    // console.log("Device:", navigator.platform);
    // console.log("Vendor:", navigator.vendor);

    // console.log("Screen Width:", window.screen.width);
    // console.log("Screen Height:", window.screen.height);

    // console.log("Orientation:", window.screen.orientation.type);

    // const connection =
    //   navigator.connection ||
    //   navigator.mozConnection ||
    //   navigator.webkitConnection;
    // console.log("Connection Type:", connection.effectiveType);

    // const connections =
    //   navigator.connection ||
    //   navigator.mozConnection ||
    //   navigator.webkitConnection;
    // console.log("Network Type:", connections.type);
    // console.log("Effective Network Type:", connections.effectiveType);

    // navigator.mediaDevices.enumerateDevices().then((devices) => {
    //   console.log("Media Devices:", devices);
    // });

    // console.log("Cookies Enabled:", navigator.cookieEnabled);
    // console.log("Do Not Track:", navigator.doNotTrack);
    // console.log("Online Status:", navigator.onLine);

    // console.log(navigator.storage);

    var socket = SocketIOClient.connect(`${REACT_APP_URL}/api/socket`, {
      transports: ["websocket"],
    });

    socket.on("connect", () => {
      console.log("Connected to server");
    });

    socket.on("disconnect", () => {
      console.log("Disconnected from server");
    });

    socket.on("msg", (data) => {
      setMsg(data);
    });

    socket.on("getCurrencies", (data) => {
      setTableCur(data);
    });
    
    socket.on("getCoins", (data) => {
      setTableCoin(data);
    });

    const getCoins = async () => {
      await fetch(`${REACT_APP_URL}/api/getallcoins`, { method: "POST" })
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          setTableCoin(data);
        })
        .catch((err) => {
          // console.log(err);
        });
    };

    const getCurrencies = async () => {
      await fetch(`${REACT_APP_URL}/api/getallcurrencies`, { method: "POST" })
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          setTableCur(data);
        })
        .catch((err) => {
          // console.log(err);
        });
    };

    const getMsg = async () => {
      await fetch(`${REACT_APP_URL}/api/getmsg`, { method: "POST" })
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          // console.log(data.msg);
          setMsg(data.msg);
        })
        .catch((err) => {
          // console.log(err);
        });
    };

    const getConfigs = async () => {
      try {
        const res = await fetch(`${REACT_APP_URL}/api/getConfig`);
        const data = await res.json();
        setConfigs(data);
      } catch (err) {
        console.log(err);
      }
    };
    
    getCoins();
    getCurrencies();
    getMsg();
    getConfigs();

    // return () => {
    //   socket.emit("disconnect");
    // };
  }, []);

  const pwaCheck = () => {
    const platform = navigator.platform;
    console.log("Device:", platform);

    // console.log(window.matchMedia('(display-mode: standalone)').matches,
    // window.navigator.standalone,
    // document.referrer.includes('android-app://'));
    if (
      platform.includes("iPhone") ||
      platform.includes("iPod") ||
      platform.includes("iPad")
    ) {
      if (
        window.matchMedia("(display-mode: standalone)").matches ||
        window.navigator.standalone
      ) {
        // count the number of pwa users in ios
      }
    }
  };

  return (
    <>
      {/*<Modal props={[status, setStatus]}/>*/}
      <div style={{ backgroundColor: "#eaf0ea", direction: "rtl" }}>
        <MyComponent />
        <Router basename="/">
          <Navbar scrolling={[scroll, setScroll]} />
          <Routes>
            <Route path={"/contact"} exact element={<Contact configs={configs} />} />
            <Route
              path={"/"}
              element={
                <Info
                  msg={msg}
                  coin={tableCoin}
                  cur={tableCur}
                  scrolling={[scroll, setScroll]}
                />
              }
            />
          </Routes>

          <TabBar scrolling={[scroll, setScroll]} />
        </Router>
      </div>
    </>
  );
}

export default App;
